module.exports = {
  background: {
    color: {
      base: 'palette.surfaceAlt',
    },
  },
  border: {
    color: {
      base: 'palette.secondaryAlt',
      error: 'palette.error',
      focus: 'palette.primary',
      hover: 'palette.primary',
      success: 'palette.success',
      warning: 'palette.warning',
    },
    radius: 'radius.lg',
    width: '1px',
  },
  color: {
    base: 'palette.secondaryAlt',
  },
  input: {
    color: {
      base: 'palette.contrastHigh',
      placeholder: 'palette.secondaryAlt',
    },
    decorationMargin: 'spacing.xxs',
    padding: {
      md: '0.6rem',
      xs: '0.375rem',
    },
  },
  outline: {
    color: {
      base: 'palette.primary',
    },
  },
};
